// **********************************************************
//  specialists-slider
// **********************************************************
/* eslint-disable */
$(function () {
  //  specialistsSlider slider
  new Swiper('.specialists-slider', {
    slidesPerView: 'auto',
    spaceBetween: 25,
    centerInsufficientSlides: true,
    autoplay: {
      delay: 5000,
    },
    freeMode: true,
    breakpoints: {
      767: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1023: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      }
    },
  });
});
/* eslint-enable */
